import { ACTIVE_SMART_LABELS, SmartLabel } from "../mail/types/mail";
import type { SmartLabelEntry } from "./types/customViews";

/**
 * (#1672 — fix ① Q-8) Garantit l'EXCLUSIVITÉ des SmartLabels (P2/INV-4) sur un jeu d'entrées reçu du
 * backend : un même `internetMessageId` ne doit apparaître que dans **un seul** label. En cas de
 * double-assignement backend (le même id dans ≥ 2 labels), on conserve la **première** occurrence dans
 * l'ordre canonique `ACTIVE_SMART_LABELS` (priorité Focus > PourInfo > Newsletter > Autre > Traités) et
 * on retire les doublons des labels suivants. Renvoie un NOUVEAU jeu (n'altère pas l'entrée), tableaux
 * clonés (snapshots immuables — pas de partage de référence avec la source).
 */
export function sanitizeExclusiveSmartLabelEntries(
    entriesByLabel: Partial<Record<SmartLabel, SmartLabelEntry[]>>,
): Partial<Record<SmartLabel, SmartLabelEntry[]>> {
    const seen = new Set<string>();
    const sanitized: Partial<Record<SmartLabel, SmartLabelEntry[]>> = {};

    for (const label of ACTIVE_SMART_LABELS) {
        const kept: SmartLabelEntry[] = [];
        for (const entry of entriesByLabel[label] ?? []) {
            if (seen.has(entry.id)) continue; // déjà attribué à un label prioritaire → doublon écarté
            seen.add(entry.id);
            kept.push(entry);
        }
        sanitized[label] = kept;
    }

    return sanitized;
}

/**
 * Convertit un tableau de SmartLabelEntry en tableau d'ids (string[]).
 * Frontière unique entre le store interne et l'API publique vers le Front.
 */
export function toIdArray(entries: SmartLabelEntry[]): string[] {
    return entries.map((e) => e.id);
}
